/**
 * @link https://develop.sentry.dev/sdk/data-model/event-payloads/contexts/#browser-context
 * @param {Navigator} navigator
 * @returns {Object}
 */
export const getBrowserContext = (navigator: Navigator) => {
  const ua = navigator.userAgent;
  const uaData = navigator.userAgentData;
  let browserName = 'Unknown';
  let browserVersion = 'Unknown';

  // Modern browsers with userAgentData
  if (uaData) {
    browserName = uaData.brands.map((b) => b.brand).join(', ') || 'Unknown';

    // Match brand specific information
    if (uaData.brands.some((b) => b.brand.includes('Chrome'))) {
      browserName = 'Chrome';
    } else if (uaData.brands.some((b) => b.brand.includes('Edge'))) {
      browserName = 'Edge';
    }
    browserVersion =
      uaData.brands.find((b) => b.brand.includes(browserName))?.version ||
      'Unknown';
  } else {
    // Legacy userAgent parsing
    if (ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('CriOS')) {
      browserName = 'Chrome';
      const match = ua.match(/Chrome\/([\d.]+)/);
      browserVersion = match ? (match[1] ?? 'Unknown') : 'Unknown';
    } else if (ua.includes('CriOS')) {
      browserName = 'Chrome (iOS)';
      const match = ua.match(/CriOS\/([\d.]+)/);
      browserVersion = match ? (match[1] ?? 'Unknown') : 'Unknown';
    } else if (ua.includes('Firefox') && !ua.includes('FxiOS')) {
      browserName = 'Firefox';
      const match = ua.match(/Firefox\/([\d.]+)/);
      browserVersion = match ? (match[1] ?? 'Unknown') : 'Unknown';
    } else if (ua.includes('FxiOS')) {
      browserName = 'Firefox (iOS)';
      const match = ua.match(/FxiOS\/([\d.]+)/);
      browserVersion = match ? (match[1] ?? 'Unknown') : 'Unknown';
    } else if (ua.includes('EdgA')) {
      browserName = 'Edge (Android)';
      const match = ua.match(/EdgA\/([\d.]+)/);
      browserVersion = match ? (match[1] ?? 'Unknown') : 'Unknown';
    } else if (ua.includes('EdgiOS')) {
      browserName = 'Edge (iOS)';
      const match = ua.match(/EdgiOS\/([\d.]+)/);
      browserVersion = match ? (match[1] ?? 'Unknown') : 'Unknown';
    } else if (ua.includes('Edg')) {
      browserName = 'Edge';
      const match = ua.match(/Edg\/([\d.]+)/);
      browserVersion = match ? (match[1] ?? 'Unknown') : 'Unknown';
    } else if (
      ua.includes('Safari') &&
      !ua.includes('Chrome') &&
      !ua.includes('CriOS')
    ) {
      browserName = 'Safari';
      const match = ua.match(/Version\/([\d.]+)/);
      browserVersion = match ? (match[1] ?? 'Unknown') : 'Unknown';
    }
  }

  return {
    name: browserName,
    version: browserVersion,
  };
};
